__turbopack_context__.v({
  "example": "KibbeReportExperience-module__dub_Tq__example",
  "exampleGrid": "KibbeReportExperience-module__dub_Tq__exampleGrid",
  "hero": "KibbeReportExperience-module__dub_Tq__hero",
  "navigation": "KibbeReportExperience-module__dub_Tq__navigation",
  "report": "KibbeReportExperience-module__dub_Tq__report",
  "takeaway": "KibbeReportExperience-module__dub_Tq__takeaway",
});
